import { render } from "./payroll-list.vue?vue&type=template&id=0b5835f8"
import script from "./payroll-list.vue?vue&type=script&lang=js"
export * from "./payroll-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__